export interface Page<T> {
  items: T[];
  nextToken?: string | null;
}

/**
 * next_token をたどって全ページを結合する（BM-004）。
 * 無限ループ防止のため maxPages ページで打ち切り、同じトークンが返った場合も停止する。
 */
export async function collectPages<T>(
  fetchPage: (nextToken?: string) => Promise<Page<T>>,
  maxPages = 10
): Promise<T[]> {
  const all: T[] = [];
  let token: string | undefined;
  const seen = new Set<string>();
  for (let page = 0; page < maxPages; page++) {
    const { items, nextToken } = await fetchPage(token);
    all.push(...items);
    if (!nextToken || seen.has(nextToken)) break;
    seen.add(nextToken);
    token = nextToken;
  }
  return all;
}
